import React from 'react';
import { Input, Select, SelectOption } from '@flixbus/honeycomb-react';

import { VoucherFormSection } from '../Section';

import { useVoucherFormContext } from '../Context';

import styles from '../voucher-form.module.scss';
import { Asterisk } from '../Asterisk';

const reasons = [
  'Goodwill gesture',
  'Payment',
  'Payment rights: Delay < 120 min.',
  'Payment rights: Delay ≥ 120 min.',
  'Payment rights: Luggage',
  'Missed interconnection',
  'Technical issues on the bus',
  'Problem with substitute bus',
];

interface VoucherFormInformationProps {
  template: {
    revenueType: string;
    voucherType: string;
    reasonField: boolean;
    specificationLabel?: string;
    specificationRequired?: boolean;
  };
}

const VoucherFormInformation: React.FC<VoucherFormInformationProps> = ({ template }) => {
  const {
    formState: {
      payload: { specification },
    },
    setFormState,
  } = useVoucherFormContext();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, prop: string) => {
    const value = e.target.value;

    setFormState(prev => ({
      ...prev,
      payload: {
        ...prev.payload,
        [prop]: value,
      },
    }));
  };

  const ContractInput = (
    <>
      <Input
        name='renevue-type'
        id='renevue-type'
        label='Revenue type'
        type='text'
        required
        value={template.revenueType}
        disabled
      />
      <Input
        name='voucher-type'
        id='voucher-type'
        label='Voucher type'
        type='text'
        required
        value={template.voucherType}
        disabled
      />
      <Input
        name='specification'
        id='specification'
        label={
          <>
            {template.specificationLabel || 'Specification'}{' '}
            {template.specificationRequired && <Asterisk />}
          </>
        }
        type='text'
        required
        value={specification}
        {...(template.reasonField ? {} : { extraClasses: styles.inputLarge })}
        onChange={e => handleInputChange(e, 'specification')}
      />
      {template.reasonField && (
        <Select
          name='reason'
          id='reason'
          required
          label={
            <>
              Reason / Issue <Asterisk />
            </>
          }
          placeholder='Select reason / issue'
        >
          {reasons.map((reason, index) => (
            <SelectOption key={index} value={reason}>
              {reason}
            </SelectOption>
          ))}
        </Select>
      )}
    </>
  );

  const inputs = <>{ContractInput}</>;

  return <VoucherFormSection title='Voucher information' inputs={inputs} />;
};

export default VoucherFormInformation;
